import React from "react";
import { ParsersPanel } from "../../api/ParsersPanel";
import { useTamrurSources } from "./hooks/useTamrurSources";
import SourcesTab from "./SourcesTab";

const fetchTamrurTimeseries = async (
  token: string,
  sourceLink: string,
  days: number,
) => (await ParsersPanel.getTamrurTimeseries(token, sourceLink, days)).series;

const TamrurSourcesTab: React.FC = () => {
  const { rows, loading, error } = useTamrurSources(7);

  return (
    <SourcesTab
      rows={rows}
      loading={loading}
      error={error}
      node="tamrur"
      sourceColumnLabel="Source URL"
      fetchTimeseries={fetchTamrurTimeseries}
    />
  );
};

export default TamrurSourcesTab;
